import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || ''
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || ''

const isConfigured = !!(SUPABASE_URL && SUPABASE_ANON_KEY)

if (!isConfigured) {
  console.warn('Supabase credentials not configured. Auth features will be disabled.')
}

// Only create Supabase client if credentials are configured
export const supabase = isConfigured ? createClient(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    }
  }
) : null

export async function signInWithDiscord() {
  if (!supabase) {
    throw new Error('Supabase is not configured')
  }
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: 'discord',
    options: {
      redirectTo: typeof window !== 'undefined' ? window.location.origin : undefined,
    }
  })
  
  if (error) throw error
  return data
}

export async function signOut() {
  if (!supabase) return
  const { error } = await supabase.auth.signOut()
  if (error) throw error
}

export async function getSession() {
  if (!supabase) return null
  const { data, error } = await supabase.auth.getSession()
  if (error) throw error
  return data?.session || null
}

export async function getAccessToken() {
  if (!supabase) return null
  // Refresh session first to ensure token is valid
  const { data, error } = await supabase.auth.refreshSession()
  if (error) {
    console.error('Failed to refresh session:', error)
    // Fall back to existing session
    const session = await getSession()
    return session?.access_token || null
  }
  return data?.session?.access_token || null
}

export function onAuthStateChange(callback) {
  if (!supabase) {
    // Return a mock subscription that does nothing
    return { unsubscribe: () => {} }
  }
  const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
    callback(event, session)
  })
  return subscription
}

export function unsubscribeAuth(subscription) {
  subscription?.unsubscribe()
}
